import { getSupabase, isSupabaseConfigured } from "../supabase/client";

/**
 * Fetched per call, never cached: a stale JWT makes the guard's `resolveUserId`
 * return null. Any failure yields `{}` so the API denies account access.
 */
export async function aiAuthHeaders(): Promise<Record<string, string>> {
  if (!isSupabaseConfigured) return {};
  try {
    const { data } = await getSupabase().auth.getSession();
    const token = data.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
